import { useTranslation } from 'react-i18next';
import { getOverlay } from '../../lib/overlays/registry';

// Vertical color scale for the active overlay, bottom-right of the map.
// Mirrors Skysight's legend: high values on top, unit label at the foot.
const OverlayLegend = ({ overlayId }) => {
    // Numeric labels pass through t() unchanged; worded labels (cloud-cover's
    // High/Mid/Low rows) get translated.
    const { t } = useTranslation();
    const overlay = getOverlay(overlayId);
    if (!overlay) return null;
    const { stops, unit } = overlay.legend;

    // Mobile: a slim, translucent strip (tiny swatches, 9px labels) so the
    // legend doesn't block the map on a phone. Desktop (sm:): larger swatches
    // and labels with air between rows — sized so even the 22-stop
    // thermal-height scale still fits comfortably beside the map.
    return (
        <div className="absolute bottom-2 right-2 sm:bottom-3 sm:right-3 z-[5] rounded sm:rounded-md bg-slate-900/60 sm:bg-slate-900/65 backdrop-blur-md shadow sm:shadow-md ring-1 ring-white/10 px-1.5 py-1.5 sm:px-2.5 sm:py-2.5 text-[9px] sm:text-[11px] leading-tight">
            <ul className="m-0 p-0 list-none space-y-0 sm:space-y-0.5">
                {stops.map((s) => (
                    <li key={s.label} className="flex items-center gap-1 sm:gap-1.5">
                        <span className="inline-block w-3 h-2 sm:w-5 sm:h-3.5 rounded-[2px] sm:rounded-sm shrink-0" style={{ backgroundColor: s.color }} />
                        <span className="text-slate-100 tabular-nums">{t(s.label)}</span>
                    </li>
                ))}
            </ul>
            {unit && <div className="mt-0.5 sm:mt-1.5 text-center font-medium text-slate-300">{unit}</div>}
        </div>
    );
};

export default OverlayLegend;
